import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  mission_advancement_id: number | null;
};

const PendingAtCell = React.memo((row: KpiWorkunitGridData) => {
  const raw = row?.mission_advancement_id;

  // mission_advancement_id is a number, empty, or null
  const id: number | null = typeof raw === 'number' && !Number.isNaN(raw) ? raw : null;

  // Mapping rules:
  // - DM completed (2,3,4) => pending at client
  // - Client completed (5,6,7) => client completed
  // - Submitted / Not submitted / empty (1,100,null) => consultant pending

  const dmDone = new Set([2, 3, 4]);
  const clientDone = new Set([5, 6, 7]);

  let label = '';
  if (id === 101) label = 'CANCELLED';
  else if (id === 102) label = 'DELETED';
  else if (id === 1) label = 'DM PENDING';
  else if (id !== null && dmDone.has(id)) label = 'CLIENT PENDING';
  else if (id !== null && clientDone.has(id)) label = 'SUBMITTED';
  else label = 'CONSULTANT PENDING';

  return (
    <>
      {label && (
        <Tooltip title={label}>
          <Typography variant="body2" noWrap>
            {label}
          </Typography>
        </Tooltip>
      )}
    </>
  );
});

export default PendingAtCell;
